<mat-card *ngIf="!loading" class="mcd-card exception-detail-card" style="border: none;">
  <mat-card-header class="exception-detail-page-header">
    <mat-card-title class="exception-detail-page-title-row">
      <button type="button" class="exception-detail-back-btn" (click)="goBack()">
        <img src="/assets/images/back to list.svg" alt="" />
        Back
      </button>
      <span class="exception-detail-page-title">
        <img src="/assets/images/standard exception icon.svg" alt="" class="exception-detail-title-icon" />
        Exception
      </span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="exception-detail-page-content">
    <div class="exception-detail-layout">
      <div class="exception-detail-main-wrap">
      <div class="exception-detail-main">
        <div class="exception-detail-toolbar">
          <nav class="exception-detail-breadcrumbs" aria-label="Breadcrumb">
            <a
              *ngIf="
                !addendumService.isCommingFromNrbes &&
                addendum?.standard?.standardTypeId == standardTypeEnum.GlobalEquipmentStandard
              "
              routerLink="/equipment-addendum-list"
              >Exceptions</a
            >
            <a
              *ngIf="
                addendumService.isCommingFromNrbes &&
                addendum?.standard?.standardTypeId == standardTypeEnum.GlobalEquipmentStandard
              "
              routerLink="/view-all-equipments"
              >Exceptions</a
            >
            <a
              *ngIf="
                !addendumService.isCommingFromNrbes &&
                addendum?.standard?.standardTypeId != standardTypeEnum.GlobalEquipmentStandard
              "
              routerLink="/addendum-list"
              >Exceptions</a
            >
            <a
              *ngIf="
                addendumService.isCommingFromNrbes &&
                addendum?.standard?.standardTypeId != standardTypeEnum.GlobalEquipmentStandard
              "
              routerLink="/nrbeslist"
              >Exceptions</a
            >
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-muted">Standard Exceptions</span>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ getExceptionTitle() }}</span>
          </nav>

          <div class="exception-detail-actions">
            <button

              type="button"
              class="exception-action-btn exception-action-btn--edit"
              (click)="redirectToRenew()"
            >
              <img src="/assets/images/social-sharing 1 (2).svg" alt="" />
              Edit
            </button>
            <button
              type="button"
              class="exception-action-btn exception-action-btn--icon exception-action-btn--download"
              [disabled]="!getDisplayDocument()"
              (click)="downloadExceptionDocument()"
              aria-label="Download exception document"
            >
              <img src="/assets/images/data-download 1.svg" alt="" />
            </button>
            <button
              type="button"
              class="exception-action-btn exception-action-btn--icon exception-action-btn--share"
              (click)="shareException()"
              aria-label="Share exception"
            >
              <img src="/assets/images/social-sharing 1.svg" alt="" />
            </button>
          </div>
        </div>

        <div
          class="exception-detail-card"
          [class.exception-detail-card--active]="isExceptionActive()"
          [class.exception-detail-card--expired]="isExceptionExpired()"
        >
          <div class="exception-detail-card-header">
            <h1 class="exception-detail-card-title">
              {{ getExceptionTitle() }}
            </h1>
            <img
              *ngIf="showExceptionStatusBadge()"
              class="exception-status-badge"
              [src]="getExceptionStatusBadge()"
              [alt]="isExceptionActive() ? 'Exception Active' : 'Exception Expired'"
            />
          </div>

          <p class="exception-detail-card-description" *ngIf="showExceptionDescription()">
            {{ addendum.description }}
          </p>

          <div class="exception-detail-meta">
            <div class="exception-detail-meta-row">
              <div class="exception-meta-item" *ngIf="getRenewalDate()">
                <img src="/assets/images/calendar 2.svg" alt="" class="exception-meta-icon" />
                <div class="exception-meta-text">
                  <span class="exception-meta-label">Renewal Date</span>
                  <span class="exception-meta-value" style="color: #34393F;">{{
                    getRenewalDate() | date : "dd MMMM, yyyy"
                  }}</span>
                </div>
              </div>

              <div class="exception-meta-divider" *ngIf="showMetaDivider()"></div>

              <div class="exception-meta-item" *ngIf="hasStatusOnDate()">
                <img
                  [src]="
                    isExceptionActive()
                      ? '/assets/images/refresh 1.svg'
                      : addendum.addendumStatus.id == addendumStatusEnum.Rejected
                        ? '/assets/images/refresh 1.svg'
                        : '/assets/images/refresh 1.svg'
                  "
                  alt=""
                  class="exception-meta-icon"
                />
                <div class="exception-meta-text">
                  <span class="exception-meta-label">{{ getStatusOnLabel() }}</span>
                  <span class="exception-meta-value" style="color: #34393F;">{{
                    addendum.approvedOrRejectedDate | date : "dd MMMM, yyyy"
                  }}</span>
                </div>
              </div>
            </div>

            <div class="exception-detail-meta-row">
              <div class="exception-meta-item">
                <img src="/assets/images/refresh 1 (1).svg" alt="" class="exception-meta-icon" />
                <div class="exception-meta-text">
                  <span class="exception-meta-label">Applicable To</span>
                  <span class="exception-meta-value" style="color: #34393F;">{{ getApplicableToLabel() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="exception-notes-section" *ngIf="addendum.note">
          <h2 class="exception-section-title">Exception Notes</h2>
          <p class="exception-notes-text">{{ addendum.note }}</p>
        </section>

        <section class="exception-document-section">
          <div
            class="exception-document-grid"
            [class.exception-document-grid--single]="!getFinalDocument()"
          >
            <div class="exception-document-column">
              <h2 class="exception-section-label">Exception Document</h2>
              <div class="exception-document-card" *ngIf="getRequestedDocument(); else noRequestedDocument">
                <div class="exception-document-info">
                  <img src="/assets/images/document-2 1.svg" alt="" class="exception-document-icon" />
                  <div class="exception-document-text">
                    <div class="exception-document-name">{{ getRequestedDocument()?.fileName }}</div>
                    <div class="exception-document-size" *ngIf="getDocumentFileSize(getRequestedDocument())">
                      {{ getDocumentFileSize(getRequestedDocument()) }}
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="exception-document-download"
                  (click)="onDownloadAddendumDocument(getRequestedDocument()?.id, getRequestedDocument()?.fileName)"
                  aria-label="Download exception document"
                >
                  <img src="/assets/images/data-download 1.svg" alt="" />
                </button>
              </div>
              <ng-template #noRequestedDocument>
                <p class="exception-no-document">No document attached.</p>
              </ng-template>
            </div>

            <div class="exception-document-column" *ngIf="getFinalDocument()">
              <h2 class="exception-section-label">Final Document</h2>
              <div class="exception-document-card">
                <div class="exception-document-info">
                  <img src="/assets/images/document-2 1.svg" alt="" class="exception-document-icon" />
                  <div class="exception-document-text">
                    <div class="exception-document-name">{{ getFinalDocument()?.fileName }}</div>
                    <div class="exception-document-size" *ngIf="getDocumentFileSize(getFinalDocument())">
                      {{ getDocumentFileSize(getFinalDocument()) }}
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="exception-document-download"
                  (click)="onDownloadAddendumDocument(getFinalDocument()?.id, getFinalDocument()?.fileName)"
                  aria-label="Download final document"
                >
                  <img src="/assets/images/data-download 1.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </section>

        <section
          class="exception-admin-section"
          *ngIf="
            ((addendum.addendumStatusId == addendumStatusEnum.Requested ||
              addendum.addendumStatusId == addendumStatusEnum.DraftAfterRequest) &&
              userRole == userRoleEnum.GlobalAdmin) ||
            canEditException()
          "
        >
          <div
            *ngIf="
              false &&
              (addendum.addendumStatusId == addendumStatusEnum.Requested ||
                addendum.addendumStatusId == addendumStatusEnum.DraftAfterRequest) &&
              userRole == userRoleEnum.GlobalAdmin
            "
            class="exception-admin-block"
          >
            <label class="exception-admin-label">Change Status</label>
            <div class="exception-admin-actions">
              <button
                [disabled]="attachmentFinal == null || invalidFile == true"
                class="btn-approve"
                (click)="approveOrRejectOrDraft(addendumStatusEnum.Approved)"
                mat-stroked-button
                type="button"
              >
                Approve
              </button>
              <button
                class="btn-reject"
                [disabled]="invalidFile"
                (click)="approveOrRejectOrDraft(addendumStatusEnum.Rejected)"
                mat-stroked-button
                color="primary"
                type="button"
              >
                Reject
              </button>
            </div>

            <div class="exception-final-upload">
              <a href="javascript:void(0);" (click)="fileInput.click()">
                <img src="/assets/images/upload.svg" alt="" />
                Upload Final Document
              </a>
              <div *ngIf="attachmentFinal != null" class="ulploaded-file">
                <a
                  href="javascript:void(0);"
                  (click)="onDownloadSelectedAddendumDocument(attachmentFinal?.id, attachmentFinal?.fileName)"
                  >{{ attachmentFinal?.fileName }}</a
                >
                <a href="javascript:void(0);" (click)="onRemoveAddendumDocument()">
                  <i class="material-icons">cancel</i>
                </a>
              </div>
              <input hidden type="file" (change)="onSelectAAddendumDocument($event)" #fileInput />
              <mat-error *ngIf="invalidFile">{{ invalidFileMessage }}</mat-error>
            </div>
          </div>

          <div class="exception-admin-block" *ngIf="canEditException()">
            <button (click)="redirectToRenew()" class="btn-approve" mat-stroked-button type="button">
              Renew Exception
            </button>
          </div>
        </section>
      </div>
      </div>

      <aside class="exception-detail-sidebar">
        <div class="exception-timeline-panel">
          <h2 class="exception-timeline-title">Exception Timeline</h2>
          <p class="exception-timeline-subtitle">
            View all activities and updates related to this exception.
          </p>

          <div class="exception-timeline-list" *ngIf="timelineEvents.length; else emptyTimeline">
            <div
              class="exception-timeline-item"
              *ngFor="let event of timelineEvents; let last = last"
              [class.exception-timeline-item--last]="last"
            >
              <div class="exception-timeline-marker">
                <span
                  class="exception-timeline-icon"
                  [ngClass]="'exception-timeline-icon--' + event.tone"
                >
                  <img [src]="event.icon" alt="" />
                </span>
                <span class="exception-timeline-line" *ngIf="!last"></span>
              </div>

              <div class="exception-timeline-content">
                <div class="exception-timeline-event-title">{{ event.title }}</div>
                <div class="exception-timeline-meta" *ngIf="event.actor">
                  {{ event.actor }}
                </div>
                <div class="exception-timeline-date" *ngIf="event.tone !== 'valid'">
                  {{ event.date | date : "dd MMMM, yyyy" }}
                </div>
                <div class="exception-timeline-note" *ngIf="event.note">
                  {{ event.note }}
                </div>
              </div>
            </div>
          </div>

          <ng-template #emptyTimeline>
            <p class="exception-timeline-empty">No timeline activity available.</p>
          </ng-template>

          <button type="button" class="exception-view-standard-btn" (click)="viewCompleteStandard()">
            <img src="/assets/images/Left Link.svg" alt="" />
            View Complete Standard
          </button>
        </div>
      </aside>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
